import { BrowserModule } from '@angular/platform-browser';
import {DropdownModule} from 'primeng/dropdown';
import {ButtonModule} from 'primeng/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ModuleWithProviders,APP_INITIALIZER } from '@angular/core';
import {InputTextModule} from 'primeng/inputtext';
import { AppComponent } from './app.component';
import { Routes, RouterModule } from '@angular/router';
import {MatFormFieldModule} from '@angular/material/form-field';
import { FormsModule ,ReactiveFormsModule , FormGroup} from '@angular/forms';
import {CardModule} from 'primeng/card';
import { MessageService } from 'primeng/api';
import {TreeTableModule} from 'primeng/treetable';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule }    from '@angular/common/http';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {TableModule} from 'primeng/table';
import { LandingComponent } from './Component/Landing/welcome.component';
import { NavBarComponent } from './Component/NavBar/navbar.component';
import { DashboardComponent } from './Component/Dashboard/dashboard.component';
import { NodeService } from './Services/api-nodeservice';
import { APIListComponent} from './Component/ApiList/app.apilist';
import {TabViewModule} from 'primeng/tabview';
import { MyAppComponent } from './Component/MyApplication/app.myapp';
import {InplaceModule} from 'primeng/inplace';
import { ViewAppComponent } from './Component/MyApplication/app.viewapp';
import { UpdateAppComponent } from './Component/MyApplication/app.updateapp';
import { ProductComponent } from './Component/MyApplication/product.component';
import {BlockUIModule} from 'primeng/blockui';
import {CheckboxModule} from 'primeng/checkbox';
import {InputMaskModule} from 'primeng/inputmask';
import { FHIRApisComponent} from './Component/FHIRApis/fhirapis.component';
import { AetnaFooterComponent} from './Component/AetnaFooter/app.aetnafooter';
import {PanelModule} from 'primeng/panel';
import {RegistrationComponent} from './Component/Registration/registration.component';
import {DocumentComponent} from './Component/Document/document.component';
import { AppConfigService } from './app-config.service';
import {AmGuardService} from './AuthGuard/amauth.guards'
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {RestApiService} from './Services/rest-api-service';
import {ProgressBarModule} from 'primeng/progressbar';
import {Message} from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {ToastModule} from 'primeng/toast';
import {DialogModule} from 'primeng/dialog';
import {FieldsetModule} from 'primeng/fieldset';
import { BasicAuthHtppInterceptorService } from './Services/BasicAuthHtppInterceptorService';
import {ApicTokenService} from './Services/apic-token-service';
import { SwaggerComponent } from './Component/swagger/swagger.component';
import {PaginatorModule} from 'primeng/paginator';
import { MatTableModule } from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import { TermsofuseComponent } from './Component/termsofuse/termsofuse.component';
import { PrivacystatementComponent } from './Component/privacystatement/privacystatement.component';
import {PublicNavBarComponent} from  './Component/PublicNavBar/publicnavbar.component';
import { RegistrationComponentSecure } from './Component/Registration/registrationsecure.component';
import { SupportComponent } from './Component/Document/support.component';
import { SubscriptionStatusComponent } from './Component/subscriptionstatus/subscriptionstatus.component';
import {MatCardModule} from '@angular/material/card';
import { StaticSwaggerComponent } from './Component/staticswagger/staticswagger.component';
import { ProdAPIListComponent } from './Component/ApiList/component.prodapilist';
import {MatIconModule} from '@angular/material/icon';
import {MatTabsModule} from '@angular/material/tabs';
import { AnnouncementComponent } from './Component/announcement/announcement.component';
import { AnnouncementPrivateComponent } from './Component/announcement-private/announcement-private.component';
import { SwaggerDetailsComponent } from './Component/swaggerdetails/swaggerdetails.component';
import { QuestionnaireComponent } from './Component/questionnaire/questionnaire.component';
import { PayerQuestionnaireComponent } from './Component/payer-questionnaire/payer-questionnaire.component';
import { DocumentationComponent } from './Component/documentation/documentation.component';

import { DocumentationSecureComponent } from './Component/documentation-secure/documentation-secure.component';

import {TooltipModule} from 'primeng/tooltip';

import { ClipboardModule } from '@angular/cdk/clipboard';
import {TreeModule} from 'primeng/tree';
import {TreeNode} from 'primeng/api';
import { ApiSegregationComponent } from './Component/api-segregation/api-segregation.component';
import { FHIRApisSegregationComponent } from './Component/fhirapis-segregation/fhirapis-segregation.component';
import { RaiseRequest } from './Component/raise-request/raise-request.component';
import { ProductsSubscriptionStatusComponent } from './Component/MyApplication/products-subscriptions-status.component';
import { BrokerQuestionnaireComponent } from './Component/broker-questionnaire/broker-questionnaire.component';
import { ProviderQuestionnaireComponent } from './Component/provider-questionnaire/provider-questionnaire.component';


const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

const routes: Routes = [
{ path: 'welcome', component: LandingComponent },
{ path: 'announcement', component: AnnouncementComponent },
{ path: 'raise-request/:status', component: RaiseRequest },
{ path: 'announcement/private', component: AnnouncementPrivateComponent },
{ path: 'swagger/:id/:path', component: SwaggerComponent },
{ path: 'fhir/apis/swagger/:file', component: StaticSwaggerComponent},
{ path: 'details/swagger/:file', component: SwaggerDetailsComponent},
{ path: 'dashboard', component: DashboardComponent ,canActivate:[AmGuardService]},
{ path: 'apis', component: APIListComponent,canActivate:[AmGuardService]},
{ path: 'apisegregation', component: ApiSegregationComponent, canActivate:[AmGuardService]},
{ path: 'myapp', component: MyAppComponent ,canActivate:[AmGuardService]},
{ path: 'fhirapis', component: FHIRApisComponent},
{ path: 'fhirapiasegregation', component: FHIRApisSegregationComponent},
{ path:'logout',redirectTo:'welcome'},
{ path: 'termsofuse', component: TermsofuseComponent },
{ path: 'gettingstarted', component: DocumentationComponent },
{ path: 'aetna/gettingstarted', component: DocumentationSecureComponent,canActivate:[AmGuardService]},
{ path: 'support', component: DocumentComponent },
{ path: 'aetna/support', component: SupportComponent ,canActivate:[AmGuardService]},
{ path: 'privacystatement',component:PrivacystatementComponent},
{ path : 'publicnavbar',component:PublicNavBarComponent},
{ path : 'subscriptionstatus',component:SubscriptionStatusComponent},
{ path : 'product-subscription-status',component:ProductsSubscriptionStatusComponent},
{ path: 'documentation', component:DocumentationComponent },
{ path: 'third-party-developer/questionnaire', component:QuestionnaireComponent, canActivate:[AmGuardService]},
{ path: 'payer/questionnaire', component:PayerQuestionnaireComponent, canActivate:[AmGuardService]},
{ path: 'broker/questionnaire', component:BrokerQuestionnaireComponent, canActivate:[AmGuardService]},
{ path: 'provider/questionnaire', component:ProviderQuestionnaireComponent, canActivate:[AmGuardService]},
{ path: '**', component:LandingComponent }
];


@NgModule({
  declarations: [
    AppComponent,
    RegistrationComponentSecure,
    LandingComponent,
    NavBarComponent,
    ProductsSubscriptionStatusComponent,
    DashboardComponent,
    SupportComponent,
    APIListComponent ,
    RaiseRequest,
    MyAppComponent,
    AnnouncementPrivateComponent,
    ViewAppComponent,
    UpdateAppComponent,
    FHIRApisComponent,
    PublicNavBarComponent,
    AetnaFooterComponent,
    RegistrationComponent,
    DocumentComponent,
    DocumentationComponent,
    DocumentationSecureComponent,
    ProductComponent,
    SwaggerComponent,
    SwaggerDetailsComponent,
    ProdAPIListComponent,
    AnnouncementComponent,
    ProviderQuestionnaireComponent,
    StaticSwaggerComponent,
    TermsofuseComponent,
    BrokerQuestionnaireComponent,
    PrivacystatementComponent,
    SubscriptionStatusComponent,
    QuestionnaireComponent,
    PayerQuestionnaireComponent,
    ApiSegregationComponent,
    FHIRApisSegregationComponent
  ],
  imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(routes,{ anchorScrolling: 'enabled'}),
        InputTextModule,
        ButtonModule,
        CardModule,
        TableModule,
        TreeModule,
        TooltipModule,
        MatIconModule,
        TreeTableModule,
        HttpClientModule,
        OverlayPanelModule,
        InputTextModule ,
        MatTabsModule,
        MatFormFieldModule,
        DropdownModule,
        FormsModule,
        TabViewModule,
        InplaceModule,
        BlockUIModule ,
        CheckboxModule ,
        PanelModule,
        InputMaskModule ,
        ProgressSpinnerModule ,
        ProgressBarModule,
        MessagesModule,
        MessageModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        ToastModule,
        DialogModule,
        FieldsetModule,
        PaginatorModule,
        MatTableModule,
        MatPaginatorModule,
        MatCardModule,
        ClipboardModule
  ],
    providers: [
     
     
      {  

        provide:HTTP_INTERCEPTORS, useClass:BasicAuthHtppInterceptorService, multi:true 
  
      },

      ApicTokenService,
      ConfirmationService,
                MessageService,
                NodeService,
                RestApiService,
                AppConfigService,
                {
                  provide: APP_INITIALIZER,
                  useFactory: appInitializerFn,
                  multi: true,
                  deps: [AppConfigService]
                }
              ],
   bootstrap: [AppComponent]
})
export class AppModule { }